export { default } from './alternate-part-labels';
